import React from 'react';
import {
  PinnedIcon,
  ButtonIcon,
  UnPinnedIcon,
  EditActionIcon,
  DeleteActionIcon,
  ButtonSpinnerProgress,
} from 'components/Ui/styled';
import Box from '@mui/material/Box';
import { formatDate } from 'utils/commonUtils';
import CopyButton from './cannedResponsesUtils';
import { HoverCopyWrapper } from './cannedResponsesStyled';
import { ActionWrapperBox } from 'components/Common/common.styled';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';

const GridTextWithCopy = (params) => {
  return (
    <HoverCopyWrapper>
      <Box sx={{ flex: 1, overflow: 'hidden' }}>{renderCellExpand(params)}</Box>

      <CopyButton text={params?.value} stopPropagation />
    </HoverCopyWrapper>
  );
};

const renderCannedResponsesActions = (params, handleEdit, handleDelete) => {
  return (
    <ActionWrapperBox>
      <ButtonIcon
        onClick={() => handleEdit(params)}
        data-testid="EditActionIcon"
      >
        <EditActionIcon />
      </ButtonIcon>
      <ButtonIcon
        onClick={() => handleDelete(params)}
        data-testid="DeleteActionIcon"
      >
        <DeleteActionIcon />
      </ButtonIcon>
    </ActionWrapperBox>
  );
};

export const cannedResponsesColumns = (
  handleEdit,
  handleDelete,
  handleTogglePin,
  pinLoading,
) => [
  {
    width: 80,
    field: 'action',
    sortable: false,
    headerName: 'Action',
    disableColumnMenu: true,
    renderCell: (params) =>
      renderCannedResponsesActions(params, handleEdit, handleDelete),
  },
  {
    width: 80,
    align: 'center',
    field: 'pinned',
    sortable: false,
    headerName: 'Pinned',
    disableColumnMenu: true,
    renderCell: (params) => {
      const isLoading = pinLoading[params?.row?.id] || false;
      const { pinned } = params?.row;
      return (
        <ButtonIcon
          onClick={() => handleTogglePin(params)}
          disabled={isLoading}
          sx={{ color: pinned && '#4f333d' }}
        >
          {pinned ? <PinnedIcon data-testid="PinnedIcon" /> : <UnPinnedIcon />}
          {isLoading && <ButtonSpinnerProgress size={24} />}
        </ButtonIcon>
      );
    },
  },
  {
    flex: 1,
    field: 'text',
    headerName: 'Text',
    renderCell: (params) => <GridTextWithCopy {...params} />,
  },
  // {
  //   flex: 1,
  //   field: 'userName',
  //   headerName: 'User Name',
  //   renderCell: renderCellExpand,
  // },
  // {
  //   flex: 1,
  //   field: 'createdAt',
  //   headerName: 'Created At',
  //   renderCell: renderCellExpand,
  // },
  // {
  //   flex: 1,
  //   field: 'updatedAt',
  //   headerName: 'Updated At',
  //   renderCell: renderCellExpand,
  // },
];

export const getCannedResponsesListData = (
  cannedResponseData,
  availableUsersList,
) => {
  if (!cannedResponseData || cannedResponseData?.length === 0) {
    return [];
  }

  return cannedResponseData.map((item) => {
    const matchedUser = availableUsersList.find(
      (user) => user?.userId === item?.userId,
    );

    const userName = matchedUser
      ? `${matchedUser?.givenName} ${matchedUser?.familyName}`
      : matchedUser?.username;

    return {
      ...item,
      text: item?.text,
      userName: userName,
      pinned: item?.pinned,
      id: item?.resourceId,
      createdAt: formatDate(item?.createdAt),
      updatedAt: formatDate(item?.updatedAt),
    };
  });
};
